export default __webpack_public_path__ + "static/media/it.61c93884.png";